<script>
  import {
    categoryMethods,
  } from '@state/helpers'

  export default {
    props: {
      type: {
        type: String,
        required: true,
      },
      childClass: {
        type: null,
        default: null,
      },
      collapse: {
        type: Boolean,
        default: false,
      },
      hasStock: {
        type: Boolean,
        default: false,
      },
      hasProduct: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        categories: [],
        model1: [],
        model2: [],
        model3: [],
        boundCollapse: false,
        filterUnmounts: {
          model1: null,
          model2: null,
          model3: null,
        }
      }
    },
    computed:{
      totalFiltered(){
        return this.model1.length + this.model2.length + this.model3.length
      }
    },
    watch: {
      model1 (val) {
        this.tryToFilter()
      },
      model2 (val) {
        this.tryToFilter()
      },
      model3 (val) {
        this.tryToFilter()
      },
    },
    async created() {
      const { data } = await this.loadCategories()
      data.forEach(el => {
        el.selected = false;
      })
      this.categories = data
      this.boundCollapse = Boolean(this.collapse)
      this.boundCollapse = !this.boundCollapse
    },
    methods: {
      ...categoryMethods,
      async loadCategories (parentId = null) {
        const params = {
          type: this.type,
          fields: 'id, name',
          limit: 500,
          orderBy: 'name',
          sortedBy: 'asc',
        }
        if (parentId) {
          params.search = `parent_id:${parentId}`
          params.skipOnlyParent = 1
        }
        if (this.hasStock) {
          params.has_stock = 1
        }
        if (this.hasProduct) {
          params.has_product = 1
        }
        const { data } = await this.getListCategories(params)
        data.data.forEach(el => {
          el.parent_id = parentId;
          el.selected = false;
        })
        return data
      },
      tryToFilter () {
        let ids = this.model3.map(el3 => el3.id)

        ids = ids.concat(this.model2.map(el => {
          if (this.model3.findIndex(m3 => m3.parent_id === el.id) === -1){
            return el.id
          } else {
            return null
          }}).filter(el => el !== null))

        ids = ids.concat(this.model1.map(el => {
          if (this.model2.findIndex(m2 => m2.parent_id === el.id) === -1){
            return el.id
          } else {
            return null
          }}).filter(el => el !== null))

        this.$emit('filter', {
          category_ids: ids,
        })
      },
      async tryToSelectCategory (category, selected, level) {
        if (selected === null){
          // need to remove
          if (level === 1) {
            // remove all descendants
            for (const cat2 of category.children) {
              // if I have grand-children remove them first
              if (cat2.children) {
                for (const cat3 of cat2.children) {
                  // remove each grandchild
                  this.model3 = this.model3.filter(cat => cat.id !== cat3.id)
                }
              }
              // remove my child
              this.model2 = this.model2.filter(cat => cat.id !== cat2.id)
            }
            // remove my self
            this.model1 = this.model1.filter(cat => cat.id !== category.id)
          } else if (level === 2) {
            // remove all descendants
            if (category.children) {
              // if I have children remove them first
              for (const cat3 of category.children) {
                this.model3 = this.model3.filter(cat => cat.id !== cat3.id)
              }
            }
            // remove my self
            this.model2 = this.model2.filter(cat => cat.id !== category.id)
          }
          this.$forceUpdate()
          return
        }

        const { data } = await this.loadCategories(category.id)
        category.children = data
        const model = `model${level}`
        this.updateModelBinding(selected, model, category);
        this.$forceUpdate()
      },
      updateModelBinding(event, model, value){
        const id = this[model].findIndex(el => el.id === value.id)
        if (event === null){
          if (id !== -1) {
            this.$delete(this[model], id)
          }
        } else {
          if (id === -1) {
            this[model].push(value)
          }
        }
      }
    },
  }
</script>

<template>
  <div :class="childClass" class="block-item">
    <div class="block-heading">
      <h3
        v-fabric-collapse.accordion-category
        class="
          tw-flex tw-items-center
          tw-text-positive
          tw-leading-relaxed tw-font-medium tw-text-base">
        <a class="tw-no-underline" href="javascript:">Category</a>
        <BaseChevronRotate
          transition-class="rotate-360-270"
          :toggle="!boundCollapse"
          :duration="500"
          :default-collapsed="collapse"
        />
      </h3>
      <FabricBadge
        :styling-bg="totalFiltered ? 'badge-primary' : 'badge-light'"
        :copy="totalFiltered"
      />
    </div>
    <FabricCollapse
      id="accordion-category"
      v-model="boundCollapse"
      hide-header
      :duration="500"
      :default-shown="!collapse">
      <div
        class="block-content"
        :class="{ 'ovf-y-scroll scroll-primary mg-r-5 pd-t-u mg-t-10 mx-h-300': (categories && categories.length > 8) }">
        <div
          v-for="category in categories"
          :key="category.id"
          class="pd-r-5"
          :class="{ 'tx-style-italics tx-col-blue': model1.length === 0 }">
          <FabricCheckbox
            v-model="category.selected"
            slot-classes="tw-pl-2"
            @update="tryToSelectCategory(category, $event, 1)"
          >{{ category.name }}</FabricCheckbox>
          <div v-if="model1.indexOf(category) >= 0" class="ml-4">
            <div 
              v-for="cat2 in category.children" 
              :key="cat2.id" 
              :class="{ 'tx-style-italics tx-col-blue': model2.findIndex(m2 => m2.parent_id === category.id) === -1 }">
              <FabricCheckbox
                v-model="cat2.selected"
                slot-classes="tw-pl-2"
                @update="tryToSelectCategory(cat2, $event, 2)"
              >{{ cat2.name }}</FabricCheckbox>
              <div v-if="model2.indexOf(cat2) >= 0" class="ml-4">
                <div 
                  v-for="cat3 in cat2.children" 
                  :key="cat3.id" 
                  :class="{ 'tx-style-italics tx-col-blue': (model3.findIndex(m3 => m3.parent_id === cat2.id) === -1) }">
                  <FabricCheckbox
                    v-model="cat3.selected"
                    slot-classes="tw-pl-2"
                    @update="updateModelBinding($event, 'model3', cat3)"
                  >{{ cat3.name }}</FabricCheckbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FabricCollapse>
  </div>
</template>
